import { useNavigate } from "react-router-dom";
import { ROUTES } from "../components/Common/Constants";

export const useRequiredAccess = (allowedRoles, allowedOrgTypes) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const currentOrgType = userDetails?.currentOrganisation?.type;
  const mainOrgType = userDetails?.mainOrganisation?.type;
  const currentOrgRole = userDetails?.currentOrgRole;
  const navigate = useNavigate();

  if (allowedOrgTypes?.length > 0) {
    if (!allowedOrgTypes.includes(currentOrgType) && !allowedOrgTypes.includes(mainOrgType)) {
      return () => navigate(ROUTES.ACCESS_DENIED.link);
    } else if (
      allowedRoles?.length > 0 &&
      !allowedRoles.includes(currentOrgRole)
    ) {
      return () => navigate(ROUTES.ACCESS_DENIED.link);
    }
  }

  return () => {};
};
